import React, { useEffect } from 'react';

import LogRocket from 'logrocket';
// import { useGetPermissionsQuery } from '../services/edgeApi';
import { useSession } from '../hooks/useSession';

export const LogRocketOutlet: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  // const { data: permissions } = useGetPermissionsQuery(undefined);
  const { user, permissions } = useSession();

  useEffect(() => {
    if (user && LogRocket.sessionURL) {
      // const user = permissions.info;
      LogRocket.identify(`${user.id}`, {
        name: user.first_name,
        email: user.email,
        role: user.role,
      });
    }
  }, [permissions, LogRocket.sessionURL]);

  return <>{children}</>;
};
